<script setup lang="ts">
import { computed } from 'vue'

import type { FlowDefinition } from '@tix/entity'

import { bundleListingColumns } from '@/helpers/bundleListingColumns'

import BundleListingItem from '@/components/bundles/BundleListingItem.vue'

export type Props = {
  flows: FlowDefinition[]
}

const props = defineProps<Props>()

const columns = computed(() => bundleListingColumns(props.flows.length))
</script>

<template>
  <ul class="bundle-listing" :class="{ 'three-columns': columns === 3 }">
    <li v-for="flow in flows" :key="flow.id">
      <BundleListingItem :flow="flow" />
    </li>
  </ul>
</template>

<style scoped>
.bundle-listing {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--padding-compact);
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;

  &.three-columns {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (--mobile-experience) {
    &,
    &.three-columns {
      grid-template-columns: minmax(0, 1fr);
    }
  }
}

.bundle-listing > li {
  min-width: 0;
  margin: 0;
  padding: 0;
}
</style>
